import { BaseObject } from '../_models/base-object';
import { BaseWaterSplitterFormGroupMapper } from './base-water-splitter-form-group.mapper';

export class WaterHeaderFormGroupMapper extends BaseWaterSplitterFormGroupMapper {
  override map(source: BaseObject, destination: BaseObject) {
    super.map(source, destination);
  }
}
